<footer class="mt-auto w-full p-4 text-center">
	<div class="copyright">© 2021 ml4all</div>
	<div class="copyright">•</div>
	<div class="copyright">Impressum</div>
	<div class="copyright">•</div>
	<div class="copyright">Datenschutzerklärung</div>
</footer>

<style>
	footer {
		background-color: var(--mdc-theme-footer);
	}
	.copyright {
		color: #aaa;
		font-size: 14px;
		display: inline-block;
		padding: 5px;
		/*border-top: 1px solid #ddd; */
	}
</style>
